import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AdminEarnings from './AdminEarnings';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';


function action({ store, intl }) {
    const title = intl.formatMessage(messages.earningsMenu);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }
    // Admin restriction
    if (!restrictUrls('/siteadmin/admin-earnings', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }
    return {
        title,
        component: (
            <AdminLayout>
                <AdminEarnings title={title} />
            </AdminLayout>
        ),
    }
}

export default action;